import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

export const CargoExpressDeliveryBadge = ({ text }) => {
	return <div className="cargo-express-delivery-badge">{text}</div>;
};

CargoExpressDeliveryBadge.propTypes = {
	text: PropTypes.any.isRequired,
};
